import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-cuenta-contable',
  templateUrl: './btn-nuevo-cuenta-contable.component.html',
  styleUrls: ['./btn-nuevo-cuenta-contable.component.css']
})
export class BtnNuevoCuentaContableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
